module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Poems from the Third Rail")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#for-leanna"
    }
  }, [_vm._v("For Leanna")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-phoenix"
    }
  }, [_vm._v("The Phoenix")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#my-mind-is-a-scape"
    }
  }, [_vm._v("My Mind Is a Scape")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#ten-thousand-chambers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten Thousand Chambers")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-prayer-for-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prayer for God")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#i-am",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Am")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#to-bear-witness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Bear Witness")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#cigarette-ash-in-my-coffee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cigarette Ash in My Coffee")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#how-to-write-a-good-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Write a Good Poem")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#i-slipped",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Slipped")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#shot-glass-lenses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shot Glass Lenses")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-maker-and-the-mold",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Maker and the Mold")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#black-dog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Dog")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#enabled",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enabled")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#milk-carton",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Carton")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#sirens",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sirens")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#an-addicts-last-prayer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Addicts Last Prayer")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#pills",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pills")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#a-block-of-writing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Block of Writing")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#coffee-stains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coffee Stains")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chinatown-boston-2022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinatown Boston 2022")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#fucked-up-and-sad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fucked up and Sad")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#kicked",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kicked")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#my-first-girl-gone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My First Girl Gone")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#sunday-morning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday Morning")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#cigarettes-and-booze",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cigarettes and Booze")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#jesus-christ",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Christ!")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#the-virus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Virus")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#the-left",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Left")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#the-middle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Middle")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#class",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(Class)")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#the-right",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Right")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#january-6th",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 6"), _c('sup', [_vm._v("th")])])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#desperation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desperation")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#faith-alarm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith Alarm")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#dark-corner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Corner")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#charred",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charred")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#fuck",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuck")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#docket-666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Docket # 666")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#bukowski",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bukowski")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#rafter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rafter")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#ink-poison",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ink Poison")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#i-am-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Am")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#whore",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whore")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#train-goddess",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Train Goddess")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#last-gasp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Gasp")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#an-open-letter-to-humanity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Open Letter to Humanity")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#hey-little-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hey, Little Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#where-did-you-go-joe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Did You Go, Joe?")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#blue-raven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Raven")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#a-song",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(A song)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0